import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createAgentUiWorkerId, processAgentUiJob } from './agentUiJobProcessor';

const IDLE_POLL_MS = 2000;
const ERROR_BACKOFF_MS = 5000;

/** Invisible, capability-gated worker owned by the authenticated embedded app. */
export function AgentUiJobWorker({ context }) {
  const workerId = useRef(createAgentUiWorkerId());
  const {
    bridgeClient,
    capabilities,
    gatewayClient,
    routeShopId,
    runtime,
  } = context;
  const supported = capabilities?.agentUiControlPlaneV1 === true;

  useEffect(() => {
    if (!supported || !bridgeClient || !gatewayClient || !runtime || !routeShopId) {
      return undefined;
    }
    let cancelled = false;
    let timer = null;
    const run = async () => {
      let delay = IDLE_POLL_MS;
      try {
        const result = await processAgentUiJob({
          bridgeClient,
          gatewayClient,
          runtime,
          shopId: routeShopId,
          workerId: workerId.current,
        });
        delay = result.status === 'completed' ? 0 : IDLE_POLL_MS;
      } catch (_error) {
        delay = ERROR_BACKOFF_MS;
      }
      if (!cancelled) timer = setTimeout(run, delay);
    };
    run();
    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [bridgeClient, gatewayClient, routeShopId, runtime, supported]);

  return null;
}

AgentUiJobWorker.propTypes = {
  context: PropTypes.shape({
    bridgeClient: PropTypes.object,
    gatewayClient: PropTypes.object,
    runtime: PropTypes.object,
    routeShopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    capabilities: PropTypes.object,
  }).isRequired,
};
